module.exports = __webpack_public_path__ + "static/media/morvan.af8a2bb2.png";